import { createContext, useContext } from "react";

export const DisclaimerCtx = createContext({ open: () => {} });
export const useDisclaimer = () => useContext(DisclaimerCtx);
